(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kmaniche-editable-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', event => {
  if (!event.target.matches('[data-product-variant]')) return;
  const root = event.target.closest('[data-editable-product]');
  const option = event.target.selectedOptions[0];
  root.querySelector('[data-product-price]').textContent = option.dataset.price;
  const button = root.querySelector('[data-product-add]');
  button.disabled = option.dataset.available !== 'true';
  button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
  const image = root.querySelector('.km-editable-product__main-image');
  if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
});
document.addEventListener('click', event => {
  const thumbnail = event.target.closest('[data-product-image]');
  if (!thumbnail) return;
  const image = thumbnail.closest('[data-editable-product]').querySelector('.km-editable-product__main-image');
  if (image) { image.removeAttribute('srcset'); image.src = thumbnail.dataset.productImage; image.alt = thumbnail.querySelector('img').alt; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kmaniche-heritage-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!input.matches('[data-heritage-pack]')) return;
  const root = input.closest('.km-product-section');
  const price = root?.querySelector('[data-km-price]');
  if (price) price.textContent = input.dataset.price;
  const compare = root?.querySelector('[data-km-compare-price]');
  if (compare) compare.hidden = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
